export default __webpack_public_path__ + "static/media/next.3c66b8f8.svg";